/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
  var currentTime = new Date();
  var currentHours = currentTime.getHours();
  
  // Log the current hours to the console
  console.log("Current Hours: ", currentHours);
  
  if (currentHours < 12) {
    // It's before 12 PM, show AM content
    document.querySelectorAll('.pm-content').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.noon-content').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.am-content').forEach(function(el) {
      el.style.display = 'block';
    });
  } else if (currentHours >= 12 && currentHours < 18) {
    // It's between 12 PM and 6 PM, show Noon content
    document.querySelectorAll('.am-content').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.pm-content').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.noon-content').forEach(function(el) {
      el.style.display = 'block';
    });
  } else {
    // It's after 6 PM, show PM content
    document.querySelectorAll('.am-content').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.noon-content').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.pm-content').forEach(function(el) {
      el.style.display = 'block';
    });
  }
});